<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{ 'main.howManyPlacePart1' | translate }}</span>
      <button mat-button class="mat-icon-button"
              (click)="dialogRef.close()"
              aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0">
    <div>{{ 'main.howManyPlacePart2' |  translate }} <b>{{ data.maxNumberOfPlace }}.</b></div>
    <mat-form-field style="width: 100%">
      <input type="number" max="{{data.maxNumberOfPlace}}" min="0" matInput [(ngModel)]="data.numberOfPlace">

    </mat-form-field>
    @if ((data.maxNumberOfPlace - (data.numberOfPlace - oldNumber)) < 0) {
      <div style="color: red">
        You cant reserve so many places.
      </div>
    }
  </div>

  <div mat-dialog-actions class="m-0 p-16 unsave-footer" fxLayout="row" fxLayoutAlign="space-between center">

      <button mat-button
        (click)="reserve()"
        [disabled]="(data.maxNumberOfPlace - (data.numberOfPlace - oldNumber) ) < 0">
        {{ 'main.reservePlace' | translate }}
      </button>
    <button mat-button (click)="dialogRef.close()">{{'close' | translate}}</button>

  </div>
</div>
